<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师分数汇总统计' url='/report/score/teach/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <ZPGLSearchDictItemSelect v-model='condition.edu' label='学历' :dictid='this.$utils.DictEnum.edu'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">带教资质：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.qualifications" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">开始时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.beginyear" type="month" placeholder="开始时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">结束时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.endyear" type="month" placeholder="结束时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium" @row-click="UserMonthly">
            <el-table-column prop="TrueName" label="姓名">
            </el-table-column>
            <el-table-column prop="CardNo" label="工号">
            </el-table-column>
            <el-table-column prop="SectionName" label="管理单元">
            </el-table-column>
            <el-table-column prop="EduName" label="学历">
            </el-table-column>
            <el-table-column label="带教资格">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.QualificationsName == '有'?'color:green;':'color:red;'">{{scope.row.QualificationsName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="CurrentCount" label="现带教人数" width="100">
            </el-table-column>
            <el-table-column prop="TotalCount" label="总带教人数" width="100">
            </el-table-column>
            <el-table-column prop="ScoreCount" label="总分" width="80">
            </el-table-column>
            <el-table-column prop="CPICount" label="评分次数" width="100">
            </el-table-column>
            <el-table-column label="平均分" width="80">
              <template slot-scope="scope">
                {{scope.row.AvgScore|formatNum}}
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScoreTeachList',
    data() {
      return {
        condition: {
          truename: '',
          section: '',
          cardno: '',
          edu: '',
          qualifications: '',
          beginyear: '',
          endyear: '',
          token: '',
          responseType: 'blob',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        options: [{
            value: '1',
            label: '有'
          },
          {
            value: '0',
            label: '无'
          }
        ],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreTeachList',
        exportUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreTeachListOut',
        loading: true,
        managesecOptions: []
      }
    },
    filters: {
      formatNum(val) {
        return val.toFixed(2)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      UserMonthly: function(row) {
        this.$router.push({
          name: 'ScoreTeachUser',
          params: {
            id: row.TecID,
            name: row.TrueName
          }
        })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      var date = new Date()
      var year = date.getFullYear()
      this.condition.beginyear = String(year) + "-1"
      this.condition.endyear = String(year) + "-12"
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
